// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#badesul-loan-data {
  display: flex;
  flex-direction: column;
}
@media (max-width: 768px) {
  #badesul-loan-data {
    height: auto;
  }
}
@media (max-width: 768px) {
  #badesul-loan-data .contracts-area {
    margin-bottom: 2rem;
  }
}
#badesul-loan-data .users-data {
  padding: 2.5rem 0;
  border-bottom: 0.063rem solid #C9D3CC;
}
@media (max-width: 768px) {
  #badesul-loan-data .users-data {
    padding-bottom: 0rem;
  }
}
#badesul-loan-data .users-data .loan-data-users-status {
  margin-top: 2.25rem;
}
@media (max-width: 768px) {
  #badesul-loan-data .users-data .loan-data-users-status {
    margin-top: 0rem;
  }
}
#badesul-loan-data .users-data .loan-data-users {
  margin-bottom: 1.5rem;
}
#badesul-loan-data .gyramais-information .interest-rate-tooltip {
  margin-left: 0.5rem;
}
#badesul-loan-data .loan-data {
  padding: 2.5rem 0;
  border-bottom: 0.063rem solid #C9D3CC;
}
@media (max-width: 768px) {
  #badesul-loan-data .loan-data {
    padding-bottom: 1rem;
  }
}
#badesul-loan-data .loan-data .ant-row {
  margin-bottom: 1.5rem;
}
@media (max-width: 768px) {
  #badesul-loan-data .loan-data .ant-row {
    margin-bottom: 0rem;
  }
}
#badesul-loan-data .loan-data-checkbox {
  padding-top: 3.5rem;
  flex-grow: 1;
}
@media (max-width: 768px) {
  #badesul-loan-data .loan-data-checkbox {
    padding-top: 2.25rem;
    margin-bottom: 1rem !important;
  }
}
#badesul-loan-data .loan-data-footer {
  border-top: 0.063rem solid #C9D3CC;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 1.25rem 3.75rem;
}
#badesul-loan-data .view-contract-btn {
  margin-left: auto;
}
@media (max-width: 768px) {
  #badesul-loan-data .view-contract-btn {
    margin: auto;
  }
}
@media (max-width: 768px) {
  #badesul-loan-data .code-row {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/others/LoanData/components/BadesulLoanData/styles.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;AAAF;AAEE;EAAA;IACE,YAAA;EACF;AACF;AAEI;EAAA;IACE,mBAAA;EACJ;AACF;AAZA;EAeI,iBAAA;EACA,qCAAA;AAAJ;AAEI;EAAA;IACE,oBAAA;EACJ;AACF;AArBA;EAuBM,mBAAA;AACN;AACM;EAAA;IACE,gBAAA;EAEN;AACF;AA7BA;EA+BM,qBAAA;AACN;AAhCA;EAqCM,mBAAA;AAFN;AAnCA;EA0CI,iBAAA;EACA,qCAAA;AAJJ;AAMI;EAAA;IACE,oBAAA;EAHJ;AACF;AA5CA;EAkDM,qBAAA;AAHN;AAKM;EAAA;IACE,mBAAA;EAFN;AACF;AApDA;EA2DI,mBAAA;EACA,YAAA;AAJJ;AAMI;EAAA;IACE,oBAAA;IACA,8BAAA;EAHJ;AACF;AA9DA;EAqEI,kCAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,wBAAA;AAJJ;AArEA;EA6EI,iBAAA;AALJ;AAOI;EAAA;IACE,YAAA;EAJJ;AACF;AAQE;EAAA;IAEI,uBAAA;EANJ;AACF","sourcesContent":["\n#badesul-loan-data{\n  display: flex;\n  flex-direction: column;\n\n  @media(max-width: @md-screen) {\n    height: auto;\n  }\n\n  .contracts-area {\n    @media(max-width: @md-screen) {\n      margin-bottom: 2rem;\n    }\n  }\n\n  .users-data {\n    padding: 2.5rem 0;\n    border-bottom: .063rem solid #C9D3CC;\n\n    @media(max-width: @md-screen) {\n      padding-bottom: 0rem;\n    }\n\n    .loan-data-users-status{\n      margin-top: 2.25rem;\n\n      @media(max-width: @md-screen) {\n        margin-top: 0rem;\n      }\n    }\n\n    .loan-data-users {\n      margin-bottom: 1.5rem;\n    }\n  }\n\n  .gyramais-information {\n    .interest-rate-tooltip{\n      margin-left: 0.5rem;\n    }\n  }\n\n  .loan-data{\n    padding: 2.5rem 0;\n    border-bottom: .063rem solid #C9D3CC;\n\n    @media(max-width: @md-screen) {\n      padding-bottom: 1rem;\n    }\n\n    .ant-row {\n      margin-bottom: 1.5rem;\n      \n      @media(max-width: @md-screen) {\n        margin-bottom: 0rem;\n      }  \n    }\n  }\n\n  .loan-data-checkbox {\n    padding-top: 3.5rem;\n    flex-grow: 1;\n\n    @media(max-width: @md-screen) {\n      padding-top: 2.25rem;\n      margin-bottom: 1rem !important;\n    }\n  }\n  \n  .loan-data-footer{\n    border-top: .063rem solid #C9D3CC;\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n    padding: 1.25rem 3.75rem;\n  }\n\n  .view-contract-btn {\n    margin-left: auto;\n\n    @media(max-width: @md-screen) {\n      margin: auto;\n    }\n  }\n  \n  \n  @media(max-width: @md-screen) {\n    .code-row {\n      justify-content: center;\n    }\n  }\n}\n\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
